import {Box, Typography} from "@material-ui/core";
import * as React from "react";
import {useEffect, useState} from "react";
import CustomTable from "../customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import './CheckOut.css'
import CheckOutDetails from "./CheckOutDetails";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {CheckoutListService, checkoutStatus} from "./CheckoutListService";
import moment from "jalali-moment";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

let selectedItemId = -1
const Checkout = () => {

    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new CheckoutListService(fundID, token, snackbar, loading)

    const [checkoutLists, setCheckoutLists] = useState([]);
    const [needRefresh, setNeedRefresh] = useState(false);


    const [itemCount, setItemCount] = useState(0);
    const [pageCount, setPageCount] = useState(0);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDataFromServer()
        }
    }, [])

    function getDataFromServer() {
        loading(setLoadingStateDispatch(true))

        service.getCheckoutList(fundID, page)
            .then(response => {
                setCheckoutListsData(response)
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason,"خطا در دریافت درخواست های تسویه!",snackbar,loading)
        })
    }

    function prepareGroupsJsonList(id, number, sendBy, sendAt, status,accountNumber) {
        return {
            id: id,
            number: number,
            fullName: sendBy,
            accountCode: accountNumber,
            date: moment(sendAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD'),
            status:
                status === checkoutStatus.AWAITING_FOR_REVIEW.id ?
                    <span className="bg_default_state">{checkoutStatus.AWAITING_FOR_REVIEW.title}</span> :
                    status === checkoutStatus.ACCEPTED.id ?
                        <span className="bg_active_state">{checkoutStatus.ACCEPTED.title}</span> :
                        status === checkoutStatus.REJECTED.id ?
                            <span className="bg_deActive_state">{checkoutStatus.REJECTED.title}</span> :
                            status === checkoutStatus.CANCELLED.id ?
                                <span className="bg_warning_state">{checkoutStatus.CANCELLED.title}</span> : "نا مشخص"
        }
    }

    function setCheckoutListsData(checkoutData) {
        setItemCount(checkoutData.numberOfItems)
        setPageCount(checkoutData.totalPage)
        setCheckoutLists([])

        checkoutData.data.map((item, index) => {
            setCheckoutLists((prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 20) + index + 1,
                    item.ownerFullName,
                    item.sendAt,
                    item.status,
                    item.depositAccountNumber
                )
            ]))
        })


    }

    //table-start
    const showEventsContent = (rowId) => {
        selectedItemId = rowId
        setOpenDialog(true);
    }
    //table-end
    const handleChange = (event, value) => {
        page = value - 1
        getDataFromServer()
    };
    const [openDialog, setOpenDialog] = useState(false);

    const handleClose = () => {
        setOpenDialog(false);
        selectedItemId = -1
        if (needRefresh) {
            setNeedRefresh(false)
            getDataFromServer()
        }
    };


    return (
        <>
            {
                <CheckOutDetails
                    openDialog={openDialog}
                    selectedItemId={selectedItemId}
                    handleClose={handleClose}
                    changeNeedRefresh={setNeedRefresh}
                />
            }
            <section className="pageContainer">
                <Box className="d-flex flex-row w-100" style={{margin: "1rem 0 1.2rem 0"}}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'baseline'}}>
                        <Typography variant={"h5"}>
                            تسویه حساب
                        </Typography>
                        {itemCount > 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {" " + itemCount + " تراکنش ثبت شده "}
                            </Typography> :
                            ''}
                    </section>
                </Box>
                <CustomTable
                    header={columns}
                    data={checkoutLists}
                    rowClicked={showEventsContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>


            </section>
        </>

    )
}
export default Checkout;
const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',
        align: 'right',
    },
    {
        id: 'accountCode',
        label: 'کد حساب',
        align: 'right',
    },
    {
        id: 'date',
        label: 'تاریخ',
        align: 'right',
    },
    {
        id: 'status',
        label: 'وضعیت',
        align: 'right'
    },
]
const rows = [
    {
        number: '1',
        fullName: 'سید حسین قریشی',
        accountCode: '14001204',
        date: '1400/12/06',
        status: 'در دست بررسی'

    },
]
